import { useBoardStore } from '@/state/boardStore';
import { showHelperOfflineDialog } from '@/features/helper/helperOfflineDialog';
import { useArduinoSetupDialogStore } from '@/state/arduinoSetupDialogStore';
import { useSerialStore } from '@/state/serialStore';
import { Box, Typography } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

export function StatusBar() {
  const { board } = useBoardStore();
  const { port, connected, baudRate, helperOnline, helperSetupRequired, getSelectedPortLabel } =
    useSerialStore();
  const showArduinoSetupDialog = useArduinoSetupDialogStore((state) => state.show);

  const helperLabel = helperOnline
    ? 'online'
    : helperSetupRequired
      ? 'setup required'
      : 'offline';
  const helperColor = helperOnline
    ? 'success.main'
    : helperSetupRequired
      ? 'info.main'
      : 'warning.main';
  const helperClickable = !helperOnline;

  const handleHelperClick = () => {
    if (helperOnline) {
      return;
    }
    if (helperSetupRequired) {
      showArduinoSetupDialog();
      return;
    }
    showHelperOfflineDialog();
  };

  return (
    <Box
      component="footer"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        px: 1.5,
        py: 0.5,
        minHeight: 26,
        borderTop: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        fontSize: 12,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          cursor: helperClickable ? 'pointer' : 'default',
        }}
        onClick={helperClickable ? handleHelperClick : undefined}
        role={helperClickable ? 'button' : undefined}
        tabIndex={helperClickable ? 0 : undefined}
        onKeyDown={
          helperClickable
            ? (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  handleHelperClick();
                }
              }
            : undefined
        }
      >
        <CircleIcon sx={{ fontSize: 8, color: helperColor }} />
        <Typography variant="caption" color={helperColor} sx={{ fontWeight: 600 }}>
          Helper {helperLabel}
        </Typography>
      </Box>

      <Typography variant="caption" color="text.secondary">
        Board: {board.displayName}
      </Typography>

      <Typography variant="caption" color="text.secondary" sx={{ display: { xs: 'none', sm: 'block' } }}>
        Port: {port ? getSelectedPortLabel() : '—'}
      </Typography>

      <Typography variant="caption" color="text.secondary" sx={{ display: { xs: 'none', md: 'block' } }}>
        Serial: {connected ? `${baudRate} baud` : 'disconnected'}
      </Typography>

      <Typography variant="caption" color="text.secondary" sx={{ display: { xs: 'none', lg: 'block' } }}>
        FQBN: {board.fqbn}
      </Typography>

      <Box sx={{ flex: 1 }} />

      <Typography variant="caption" color="text.secondary">
        Skyrover IDE v0.1.0
      </Typography>
    </Box>
  );
}
